<div class="week-number">
  {{ calendarService.weekNumberLabel$ | async }}
</div>
<div class="week-selector">
  <div
    (click)="previousMonth()"
    [class.month-picker__button--disabled]="isPreviousMonthDisabled"
    class="month-picker__button test-booking-month-prev-btn"
  >
    <app-ui-icon color="var(--green-2)" name="chevron_back" size="sm"></app-ui-icon>
    Tidigare
  </div>
  <div class="week-label">{{ calendarService.weekLabel$ | async }}</div>
  <div
    (click)="nextMonth()"
    class="month-picker__button test-booking-month-next-btn"
  >
    Senare
    <app-ui-icon color="var(--green-2)" name="chevron_right" size="sm"></app-ui-icon>
  </div>
</div>
